const StartStopbtn = ({
    positiveFunc,
    negativeFunc,
    negativeText,
    positiveText,
    positiveClassName,
    negativeClassName,
    styles,
    positiveActive,
    negativeActive,
    parentDivClassName
}) => {
    return (
        <div className={parentDivClassName}>
            <button
                disabled={positiveActive}
                onClick={() => positiveFunc()}
                className={!positiveActive ? positiveClassName : ""}>
                {positiveText}
            </button>
            <button
                disabled={negativeActive}
                onClick={() => negativeFunc()}
                className={negativeClassName}>
                {negativeText}
            </button>
        </div>
    );
};

export default StartStopbtn;
